/** Battle config registry (owner: combat-builder). Content JSON is registered here by id. */
import type { BattleConfig } from '@/core/types/contracts';
import swordTraining from '@/content/combat/sword-training.json';
import type { SwordTrainingConfig } from './types';

export const SWORD_TRAINING = swordTraining as unknown as SwordTrainingConfig;

export const BATTLES: Record<string, BattleConfig | SwordTrainingConfig> = { [SWORD_TRAINING.id]: SWORD_TRAINING };

export function registerBattles(list: (BattleConfig | SwordTrainingConfig)[]): void { for (const b of list) BATTLES[b.id] = b; }
export function getBattle(id: string): BattleConfig | SwordTrainingConfig | undefined { return BATTLES[id]; }
